
export default function Borrowers() {
  return (
    <section id="borrowers" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* 左側：3D 圖示與說明 */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7dc841f9337f7c0dc0b26049d89ec8ec.jpg"
                alt="金融網絡系統"
                className="w-full h-full object-cover"
              />
              
              {/* 左下角標籤 */}
              <div className="absolute bottom-8 left-8 bg-white/95 backdrop-blur-sm rounded-2xl px-6 py-4 shadow-xl">
                <div className="text-gray-700 text-lg font-medium mb-1">專業・讓資金不再是難題</div>
                <div className="text-3xl font-bold text-gray-900">
                  核貸成功率提升 <span className="text-orange-500">30%+</span>
                </div>
              </div>

              {/* 右上角橘色標籤 */}
              <div className="absolute top-8 right-8 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-2">
                <i className="ri-award-line text-xl"></i>
                <span className="font-semibold text-sm">查看所有服務項目</span>
              </div>
            </div>
          </div>

          {/* 右側：服務特色 */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-12">朋睿服務特色</h2>

            <div className="space-y-8">
              {/* 特色 1 */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-2xl text-gray-700"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">專人全程陪同</h3>
                  <p className="text-gray-600 leading-relaxed">
                    從跟行洽談到審核完成，我們全程陪同，協助準備所有相關文件。
                  </p>
                </div>
              </div>

              {/* 特色 2 */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-settings-3-line text-2xl text-gray-700"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">量身客製規劃</h3>
                  <p className="text-gray-600 leading-relaxed">
                    不推銷單一商品，而是依據您的財報狀況提供最適合的方案。
                  </p>
                </div>
              </div>

              {/* 特色 3 */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-pie-chart-line text-2xl text-gray-700"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">整合負債優化</h3>
                  <p className="text-gray-600 leading-relaxed">
                    運用低利率天期政策專案，協助整合現有高利負債，降低成本付息。
                  </p>
                </div>
              </div>

              {/* 特色 4 */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-funds-line text-2xl text-gray-700"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">多元資金渠道</h3>
                  <p className="text-gray-600 leading-relaxed">
                    連結政府補助、銀行貸款與民間資金等多元管道，分散風險，提高成功率。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
